import { render } from "./Walks.vue?vue&type=template&id=3c81bd07&scoped=true"
import script from "./Walks.vue?vue&type=script&lang=js"
export * from "./Walks.vue?vue&type=script&lang=js"

import "./Walks.vue?vue&type=style&index=0&id=3c81bd07&scoped=true&lang=css"

import exportComponent from "/Users/jessicabohland/Documents/Code/Website/gonsbachtal-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c81bd07"]])

export default __exports__